import { createAction } from 'redux-actions';

export const clearReservationArchived = createAction(
  'CLEAR_RESERVATION_ARCHIVED'
);

export const reservationArchivedOnChangePage = createAction(
  'RESERVATION_ARCHIVED_ON_CHANGE_PAGE'
);

export const reservationArchivedOnChangeOrder = createAction(
  'RESERVATION_ARCHIVED_ON_CHANGE_ORDER'
);

export const reservationArchivedRemoveItem = createAction(
  'RESERVATION_ARCHIVED_REMOVE_ITEM'
);
